module.exports = "/_assets/images/branding/corval-logo-rgb.svg";